import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { AEP_SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallAepPharmacy = () => <PrecallSurvey step={AEP_SurveyStep.PHARMACY} />;

export default PrecallAepPharmacy;
